import { RouterModule, Routes } from "@angular/router";

import { PollsComponent } from "./polls/polls.component";
import { CreatePollComponent } from "./polls/createpoll.component";
import { EditPollComponent } from "./polls/editpoll.component";
import { AlertsComponent } from "./alerts/alerts.component";
import { CreateAlertComponent } from "./alerts/createalert.component";
import { EditAlertComponent } from "./alerts/editalert.component";
import { PostsComponent } from "./posts/posts.component";
import { CreatePostComponent } from "./posts/createpost.component";
import { EditPostComponent } from "./posts/editpost.component";
import { ProfilesComponent } from "./profiles/profiles.component";
import { PollResponsesComponent } from "./pollresponses/pollresponses.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { BindingsComponent } from "./bindings/bindings.component";
import { CreateNotificationComponent } from "./notifications/createnotification.component";
import { AccountListComponent } from "./accounts/accountlist.component";
import { AccountDetailComponent } from "./accounts/accountdetail.component";
import { UserDetailComponent } from "./accounts/userdetail.component";
import { CreateAccountComponent } from "./accounts/createaccount.component";
import { EditAccountComponent } from "./accounts/editaccount.component";

import { ProjectsComponent } from "./projects/projects.component";
import { CreateProjectComponent } from "./projects/createproject.component";
import { EditProjectComponent } from "./projects/editproject.component";
import { UsersComponent } from "./users/users.component";
import { CreateUserComponent } from "./users/createuser.component";
import { EditUserComponent } from "./users/edituser.component";
import { CompaniesComponent } from "./companies/companies.component";
import { CreateCompanyComponent } from "./companies/createcompany.component";
import { EditCompanyComponent } from "./companies/editcompany.component";

const routes: Routes = [
  { path: "", component: PostsComponent },
  { path: "polls", component: PollsComponent },
  { path: "pollresponses", component: PollResponsesComponent },
  { path: "createpoll", component: CreatePollComponent },
  { path: "editpoll", component: EditPollComponent },
  { path: "alerts", component: AlertsComponent },
  { path: "createalert", component: CreateAlertComponent },
  { path: "editalert", component: EditAlertComponent },
  { path: "posts", component: PostsComponent },
  { path: "createpost", component: CreatePostComponent },
  { path: "editpost", component: EditPostComponent },
  { path: "profiles", component: ProfilesComponent },
  { path: "notifications", component: NotificationsComponent },
  { path: "bindings", component: BindingsComponent },
  { path: "createnotification", component: CreateNotificationComponent },
  { path: "accounts", component: AccountListComponent },
  { path: "accounts/:id", component: AccountDetailComponent },
  { path: "userdetail", component: UserDetailComponent },
  { path: "createaccount", component: CreateAccountComponent },
  { path: "editaccount", component: EditAccountComponent },
  { path: "projects", component: ProjectsComponent },
  { path: "createproject", component: CreateProjectComponent },
  { path: "editproject", component: EditProjectComponent },
  { path: "users", component: UsersComponent },
  { path: "createuser", component: CreateUserComponent },
  { path: "edituser", component: EditUserComponent },
  { path: "companies", component: CompaniesComponent },
  { path: "createcompany", component: CreateCompanyComponent },
  { path: "editcompany", component: EditCompanyComponent }
];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.routing.ts